import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "history-area" }
const _hoisted_2 = { class: "operation-list" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "拷贝图层"),
    /*#__PURE__*/_createElementVNode("span", null, "⌘C / Ctrl + C")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "粘贴图层"),
    /*#__PURE__*/_createElementVNode("span", null, "⌘V / Ctrl + V")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "删除图层"),
    /*#__PURE__*/_createElementVNode("span", null, "Backspace / Delete")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "取消选中"),
    /*#__PURE__*/_createElementVNode("span", null, "ESC")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "撤销"),
    /*#__PURE__*/_createElementVNode("span", null, "⌘Z / Ctrl + Z")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "重做"),
    /*#__PURE__*/_createElementVNode("span", null, " ⌘⇧Z / Ctrl + Shift + Z")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "上下左右移动一像素"),
    /*#__PURE__*/_createElementVNode("span", null, " ↑ ↓ → ←")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "shortcut-key" }, [
    /*#__PURE__*/_createElementVNode("span", null, "上下左右移动十像素"),
    /*#__PURE__*/_createElementVNode("span", null, "Shift + ↑ ↓ → ←")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionOutlined = _resolveComponent("QuestionOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_UndoOutlined = _resolveComponent("UndoOutlined")!
  const _component_RedoOutlined = _resolveComponent("RedoOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(" 快捷键提示 ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "circle",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = true))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_QuestionOutlined)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(" 撤销 ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "circle",
              disabled: _ctx.undoIsDisabled,
              onClick: _ctx.undoHistory
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_UndoOutlined)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(" 重做 ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "circle",
              disabled: _ctx.redoIsDisabled,
              onClick: _ctx.redoHistory
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_RedoOutlined)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      title: "快捷键操作",
      width: "400px",
      footer: null
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}